exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flexBox__editInner-module___1jXjc {\n    width: 100%;\n  }\n  \n  .buttonCompanyInfo__editInner-module___mfYPq {\n      margin-top: 24px;\n  }\n  \n  @media (max-width: 375px) {\n    .flexBox__editInner-module___1jXjc {\n      min-width: 260px;\n    }\n  }\n  \n  @media (min-width: 769px) {\n    .flexBox__editInner-module___1jXjc {\n      \n      min-width: 1570px;\n    }\n\n    .flexBoxPage1__editInner-module___lTf0Q {\nmin-width: 870px;\n    }\n  }\n  ", ""]);

// Exports
exports.locals = {
	"flexBox": "flexBox__editInner-module___1jXjc",
	"buttonCompanyInfo": "buttonCompanyInfo__editInner-module___mfYPq",
	"flexBoxPage1": "flexBoxPage1__editInner-module___lTf0Q"
};